define([
    "underscore",
    "backbone",
    "backbone.form"
], function (_, Backbone) {
    return Backbone.Form.extend({
        validation: {
            login: {
                required: true,
            },
            password: {
                required: true,
            },
            remember_me: {
                required: true,
            }
        },

        labels: {
            login: "Login",
            password: "Password",
            remember_me: "Remember me"
        }
    });
});
